<div class="next-lesson-wrapper  {{class}}"
     [ngClass]="{'practice':practice, 'past-lesson': isPast, 'is-schedule':isSchedule}"
     *transloco="let t; read: 'nextLessonComp'">

    <div class="vertical-line ion-hide-md-down"></div>

    <div class="info">
        <div class="vertical-line ion-hide-md-up "></div>
        <div class="title"
             *ngIf="!isPast && !isSchedule && !isTransferredLesson && !data.hasBeenTransferredTo"> {{ practice ? t('practiceLesson') : t('nextLesson') }} {{ data.lessonNumber }}
        </div>

        <div class="title"
             *ngIf="!isPast && !isSchedule && !isTransferredLesson && data.hasBeenTransferredTo"> {{ practice ? t('practiceLesson') : t('nextLesson') }} {{ data.lessonNumber }}

            <div class="today-wrapper transfer">
                <img src="assets/images/icons/red_flag.svg" alt="flag">
                 {{ t('transferTo') }} {{ data.hasBeenTransferredTo }}
            </div>

        </div>


        <div class="title" *ngIf="!isPast && isSchedule && !isTransferredLesson">{{ title }}</div>
        <div class="title" *ngIf="isPast">  {{ t('lessonsAreFinished') }} </div>


        <div class="title" *ngIf="isTransferredLesson"> {{t('lessonHasBeenTransferred')}} {{ data.lessonNumber }}
            <div class="today-wrapper" *ngIf="data.isToday">

                <img src="assets/images/icons/flag.svg" alt="flag">

              {{t('today') }}


            </div>
        </div>

        <div class="details">
            <div class="time">
                <img src="assets/images/icons/clock.svg" alt="clock">
                {{ isPast ? '_' : data.time }}
            </div>

            <div class="date" *ngIf="!isPast">
                <img src="assets/images/icons/calendar.svg" alt="calendar">

<!--                {{ data.dateDay|transloco }}, <span>{{ data.dateMonth }}</span>-->
                {{ data.dateDay }}, <span>{{ data.dateMonth }}</span>
            </div>

            <div class="date" *ngIf="isPast">
                <img src="assets/images/icons/calendar.svg" alt="calendar">
                _
            </div>
        </div>


    </div>

    <div class="btn-wrapper" *ngIf="isCurrent && !isSchedule" [ngClass]="{'disable': hideButton}">

        <button type="button" class="btn dark-btn" *ngIf="data.url" (click)="openUrl(data.url)"
                [ngClass]="{'not-allowed grey-blocked has-transferred': data.hasBeenTransferredTo , 'not-allowed early-grey-block': isTransferredLesson && !data.activateLink}"
                [disabled]="data.hasBeenTransferredTo || (isTransferredLesson && !data.activateLink) || data?.isReserve">
            {{t('joinTheLesson') }}
            <div class="has-transferred-message" *ngIf="data.hasBeenTransferredTo">
                <div class="info">
                    {{ t('alreadyTransferred') }}

                </div>
            </div>

            <div class="early-message" *ngIf="isTransferredLesson && !data.activateLink">
                <div class="info">
                  {{t('zoom')}}
                </div>
            </div>


        </button>


        <div class="soon-wrapper" *ngIf="!data.url ">
            <img src="assets/images/icons/spaceship.svg" alt="spaceship">
            {{t('seeUAtSchool')}}

        </div>


        <div *ngIf="isTransferredLesson" (click)="openTransferModal('cancel')" class="btn-cancel">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M30 10L10 30" stroke="#333433" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M10 10L30 30" stroke="#333433" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
            </svg>

        </div>
    </div>

    <div class="btn-wrapper static" *ngIf="isCurrent && isSchedule">

        <div class="next-wrapper">
            {{t('next')}}
        </div>
    </div>


</div>
